import React, { useState } from 'react'
import { Flex, Text, Card, Divider } from '@chilipiper/design-system'
import last from 'lodash/last'
import { UserAvatar } from '@chilipiper/meetings-components'
import { GroupMembersDropdownArrowIcon } from './GroupMembersDropdownArrowIcon'

interface Props {
  members: any[]
}

export const GroupMembersDropdown: React.FC<Props> = ({ members }) => {
  const [displayDropdown, setDisplayDropdown] = useState(false)
  const openDropdown = () => setDisplayDropdown(true)
  const closeDropdown = () => setDisplayDropdown(false)
  return (
    <Flex position='relative'>
      <GroupMembersDropdownArrowIcon onMouseOver={openDropdown} onMouseLeave={closeDropdown} />
      {displayDropdown ? (
        <Card
          data-chili-css='group-members-dropdown'
          zIndex={10}
          mt={3}
          ml={0}
          position='absolute'
          right={[0, 'unset', 'unset']}
        >
          {members.map((member: any) => (
            <Flex key={member.id} p={2} w='auto' alignItems='start' flexDirection='column'>
              <Flex alignItems='center'>
                <UserAvatar
                  isTwoInitials
                  name={member.name}
                  size={5}
                  id={member.id}
                  borderRadius={4}
                  imageStyle={{
                    boxShadow: 'none',
                    boxSizing: 'content-box',
                  }}
                />
                <Text data-chili-css='group-members-dropdown-member' fontWeight={500} ml={2}>
                  {member.name}
                </Text>
              </Flex>
              {last(members) === member ? null : <Divider width='100%' mt={2} />}
            </Flex>
          ))}
        </Card>
      ) : null}
    </Flex>
  )
}
